var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6923 2.53845H3.30769C2.03319 2.53845 1 3.57164 1 4.84614V18.6923C1 19.9668 2.03319 21 3.30769 21H18.6923C19.9668 21 21 19.9668 21 18.6923V4.84614C21 3.57164 19.9668 2.53845 18.6923 2.53845Z",
    stroke: "#606060",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9229 11C13.5601 11 14.0767 10.4834 14.0767 9.84617C14.0767 9.20892 13.5601 8.69232 12.9229 8.69232C12.2856 8.69232 11.769 9.20892 11.769 9.84617C11.769 10.4834 12.2856 11 12.9229 11Z",
    fill: "#606060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7691 11C17.4063 11 17.9229 10.4834 17.9229 9.84617C17.9229 9.20892 17.4063 8.69232 16.7691 8.69232C16.1318 8.69232 15.6152 9.20892 15.6152 9.84617C15.6152 10.4834 16.1318 11 16.7691 11Z",
    fill: "#606060"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9229 14.8461C13.5601 14.8461 14.0767 14.3296 14.0767 13.6923C14.0767 13.055 13.5601 12.5385 12.9229 12.5385C12.2856 12.5385 11.769 13.055 11.769 13.6923C11.769 14.3296 12.2856 14.8461 12.9229 14.8461Z",
    fill: "#606060"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7691 14.8461C17.4063 14.8461 17.9229 14.3296 17.9229 13.6923C17.9229 13.055 17.4063 12.5385 16.7691 12.5385C16.1318 12.5385 15.6152 13.055 15.6152 13.6923C15.6152 14.3296 16.1318 14.8461 16.7691 14.8461Z",
    fill: "#606060"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23099 14.8461C5.86825 14.8461 6.38484 14.3296 6.38484 13.6923C6.38484 13.055 5.86825 12.5385 5.23099 12.5385C4.59374 12.5385 4.07715 13.055 4.07715 13.6923C4.07715 14.3296 4.59374 14.8461 5.23099 14.8461Z",
    fill: "#606060"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0767 14.8461C9.71395 14.8461 10.2305 14.3296 10.2305 13.6923C10.2305 13.055 9.71395 12.5385 9.0767 12.5385C8.43945 12.5385 7.92285 13.055 7.92285 13.6923C7.92285 14.3296 8.43945 14.8461 9.0767 14.8461Z",
    fill: "#606060"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23099 18.6923C5.86825 18.6923 6.38484 18.1757 6.38484 17.5385C6.38484 16.9012 5.86825 16.3846 5.23099 16.3846C4.59374 16.3846 4.07715 16.9012 4.07715 17.5385C4.07715 18.1757 4.59374 18.6923 5.23099 18.6923Z",
    fill: "#606060"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0767 18.6923C9.71395 18.6923 10.2305 18.1757 10.2305 17.5385C10.2305 16.9012 9.71395 16.3846 9.0767 16.3846C8.43945 16.3846 7.92285 16.9012 7.92285 17.5385C7.92285 18.1757 8.43945 18.6923 9.0767 18.6923Z",
    fill: "#606060"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9229 18.6923C13.5601 18.6923 14.0767 18.1757 14.0767 17.5385C14.0767 16.9012 13.5601 16.3846 12.9229 16.3846C12.2856 16.3846 11.769 16.9012 11.769 17.5385C11.769 18.1757 12.2856 18.6923 12.9229 18.6923Z",
    fill: "#606060"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84619 1V2.53846M17.1539 1V2.53846",
    stroke: "#606060",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.38464H1",
    stroke: "#606060",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.318eb2a65103086a1f184455524f99cd.svg";
export { ForwardRef as ReactComponent };